<!-- {{'CONTRACTS.CARD.BANK_PRODUCTS'|translate}} -->
<div class="contract-products">
    <div class="contract-products-title" (click)="hideBlock=!hideBlock">
          {{'CONTRACTS.CARD.ASK_PRODUCT'|translate}}
        <mat-icon  class="black-icon" style="width: 18px;" [svgIcon]="hideBlock? 'arrow-down-s-line' : 'arrow-up-s-line'"> </mat-icon>
    </div>
  <div class="contract-products-list" *ngIf="hideBlock === false" >
    <div class="contract-products-list-item" style="cursor: pointer;" (click)="requestProduct(item.key)" *ngFor="let item of bankProductsMap | keyvalue">
      <div class="contract-products-list-item-border">
        <mat-icon [svgIcon]="item.value.icon" class="base-icon" style="width: 30px;height: 30px;"></mat-icon>
      </div> 
      <div  class="contract-products-list-item-label" >  {{('CONTRACTS.CARD.PRODUCTS.'+item.key) |translate}}</div>
    </div>
  </div>
</div>